var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTradein(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V22C36 25.3137 33.3137 28 30 28H6C2.68629 28 0 25.3137 0 22V6Z",
    fill: "#F39DBD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7908_49236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3626 12.36V13.1644C18.3626 13.4199 18.4137 13.6343 18.5144 13.8013C18.6533 14.0317 18.8813 14.1638 19.1402 14.1638C19.3939 14.1638 19.646 14.0403 19.8894 13.7969L22.5463 11.1399C23.1297 10.5565 23.1297 9.6073 22.5463 9.02393L19.8894 6.36694C19.646 6.12341 19.3939 6 19.1402 6C18.7531 6 18.3626 6.30908 18.3626 6.99939V7.72998C14.5904 7.95276 11.4676 10.8477 11.0035 14.6378C10.9775 14.8495 11.0979 15.0521 11.2962 15.1306C11.3524 15.1528 11.4109 15.1636 11.4686 15.1636C11.6148 15.1636 11.7567 15.0951 11.847 14.9717C13.0919 13.2708 15.0907 12.2552 17.1937 12.2552C17.5833 12.2552 17.9752 12.2904 18.3626 12.36Z",
    fill: "#E83274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6954 12.8689C24.497 12.7903 24.2707 12.8557 24.1446 13.028C22.8998 14.7288 20.901 15.7443 18.798 15.7443C18.4084 15.7443 18.0165 15.7091 17.6291 15.6395V14.8351C17.6291 14.1448 17.2384 13.8357 16.8515 13.8357C16.5978 13.8357 16.3457 13.9592 16.1022 14.2028L13.4452 16.8596C12.862 17.443 12.862 18.3922 13.4454 18.9757L16.1022 21.6326C16.3457 21.8761 16.5978 21.9995 16.8515 21.9995C17.2384 21.9995 17.6291 21.6905 17.6291 21.0002V20.2696C21.4014 20.0468 24.5241 17.1519 24.9882 13.3618C25.0142 13.15 24.8938 12.9474 24.6954 12.8689Z",
    fill: "#E83274"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7908_49236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradein);
export default __webpack_public_path__ + "static/media/Акция-trade in.98b89fc0a5fc87c2a9ebd76bd5caee76.svg";
export { ForwardRef as ReactComponent };